require.context('../images', true);

import 'styles/courses_widget/index.scss';
import 'scripts/courses_widget/index.js';
